import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AppLayout } from '../templates/AppLayout/AppLayout';
import { Header } from '../layout/Header';
import { Sidebar } from '../Sidebar';
import { PageContent } from '../templates/PageContent';
import { LiveRegion } from '../atoms/LiveRegion/LiveRegion';
import { Text } from '../atoms/Typography/Text';
import { useTranslation } from '../../i18n/useTranslation';
import { useVoiceJournal } from './CaptureContext';

/**
 * Pages that ship with the voice journal (guided test session, emergency help)
 * only open while it is switched on (VOICE_CAPTURE_ENABLED); otherwise a direct
 * link lands on the aquarium's `fallback` page (the normal test session, the
 * incident list).
 */
export function VoiceJournalRoute({ fallback, children }: { fallback: string; children: ReactNode }) {
  const { t } = useTranslation();
  const { aquariumId = '' } = useParams<{ aquariumId: string }>();
  const state = useVoiceJournal();
  if (state === 'off') return <Navigate to={`/aquariums/${encodeURIComponent(aquariumId)}/${fallback}`} replace />;
  if (state === 'loading') {
    return (
      <AppLayout
        header={<Header />}
        sidebar={<Sidebar />}
        main={
          <PageContent width="narrow">
            <LiveRegion busy>
              <Text>{t('common.loading')}</Text>
            </LiveRegion>
          </PageContent>
        }
      />
    );
  }
  return <>{children}</>;
}

export default VoiceJournalRoute;
